import { IconButton, IconButtonProps } from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";

export type SideBarToggleButtonProps = Omit<
  IconButtonProps,
  "aria-label" | "aria-controls" | "aria-expanded" | "icon" | "onClick"
> & {
  isMobileSideBarHidden?: boolean;
  isMobileSideBarOpen: boolean;
  onToggle: () => void;
};

export default function SideBarToggleButton({
  isMobileSideBarHidden,
  isMobileSideBarOpen,
  onToggle,
  ...rest
}: SideBarToggleButtonProps) {
  if (isMobileSideBarHidden) {
    return null;
  }

  return (
    <IconButton
      icon={<HamburgerIcon boxSize={7} />}
      variant="ghost"
      display={{ md: "none" }}
      borderRadius="md"
      p={2}
      color="magenta.dark"
      aria-label="Open or close side bar menu"
      aria-expanded={isMobileSideBarOpen}
      aria-controls="SideBar"
      _expanded={{ boxShadow: "inner", bg: "gray.50" }}
      alignSelf="center"
      onClick={onToggle}
      {...rest}
    />
  );
}
